import { styled } from '@stitches/react';
import { ReactNode, useMemo } from 'react';
import { useElements, useScene } from '../../hooks';

export const ButtonElement = ({
  elementID,
  children,
}: {
  elementID: string;
  children: ReactNode;
}) => {
  const scene = useScene();
  const [element] = useElements({ id: elementID });

  const Button = useMemo(
    () => styled('div', element?.props?.class as {}),
    [element?.props?.class]
  );

  return (
    <Button
      element-type="button"
      id={element?.id}
      {...scene.launcherStateProps}
    >
      {children}
    </Button>
  );
};
